export const initQuotationRoutes = (config: any, enabled: boolean = true) =>
  !enabled
    ? []
    : [
        {
          path: "/manage/quotations",
          name: "quotation",
          component: () => import("@/pages/manage/quotations/index.vue"),
          meta: {
            requiresAuth: true,
            roles: [
              config.roles.administrators,
              config.roles.siteEditors,
            ],
          },
        },
        {
          path: "/manage/quotations/:id",
          name: "quotation-id",
          component: () => import("@/pages/manage/quotations/id.vue"),
          meta: {
            requiresAuth: true,
            roles: [
              config.roles.administrators,
              config.roles.siteEditors,
            ],
          },
        },
      ];
